module.exports = __webpack_public_path__ + "img/premium-crown.11899e32.svg";